import { render, staticRenderFns } from "./MultiLangProductMaintain.vue?vue&type=template&id=0ce7dee4&scoped=true"
import script from "./MultiLangProductMaintain.vue?vue&type=script&lang=js"
export * from "./MultiLangProductMaintain.vue?vue&type=script&lang=js"
import style0 from "./MultiLangProductMaintain.vue?vue&type=style&index=0&id=0ce7dee4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce7dee4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce7dee4')) {
      api.createRecord('0ce7dee4', component.options)
    } else {
      api.reload('0ce7dee4', component.options)
    }
    module.hot.accept("./MultiLangProductMaintain.vue?vue&type=template&id=0ce7dee4&scoped=true", function () {
      api.rerender('0ce7dee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/i18n/MultiLangProductMaintain.vue"
export default component.exports